import React from 'react';
const FooterSection = () => {
  return (
    <section className="footer">

      <div className="credit">
        created by <span>Anjali Chaudhary</span> | all rights reserved.
      </div>
    </section>
  );
};

export default FooterSection;
